import type { ToastOptions } from "./toast.type";

const toAddOptions = ({ title, duration, id, action, onClose }: ToastOptions) => ({
  title,
  id,
  onClose,
  timeout: duration,
  actionProps: action && { children: action.label, onClick: action.onClick },
});

export { toAddOptions };
